export const codeMigrateToTokensJS = `// CSS in JS
+import { token } from '@atlaskit/tokens';

export default () => <div css={{
-  color: B400,
+  color: token('color.background.selected.bold'),
}} />`;

export const codeMigrateToTokensCSS = `// CSS variables, Sass, Less
.bg-surface {
  background: var(--ds-surface-raised, #eeeeee);
}`;

export const codeTokensCodemmod = ` export const dangerMessageStyles = css({
-  backgroundColor: colors.R50,
+  backgroundColor: token('color.background.danger'),

  ':hover': {
-    backgroundColor: colors.R60,
+    backgroundColor: token('color.background.danger.hovered'),
  },

  ':active': {
-    backgroundColor: colors.R80,
+    backgroundColor: token('color.background.danger.pressed'),
  },
});`;

export const codeCodemodCli = `# For CSS in JS
npx @hypermod/cli --packages="@atlaskit/tokens#theme-to-design-tokens" --experimental-loader --parser tsx <relative-path>
# For vanilla CSS, Sass, Less
npx @hypermod/cli --packages="@atlaskit/tokens#css-to-design-tokens" --extensions css,scss,less <relative-path>`;
